module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/01-5734d427942268e242860116e06e8375.jpg";